module.exports = __webpack_public_path__ + "static/media/back_arrow.78ed50b3.png";